import axios from "axios";

export default {
  namespaced: true,
  state: {
    counts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    countsMessage: ''
  },
  mutations: {
    CLEAR_INVENTORY_COUNTS(state) {
      state.counts = [];
    },
    RECEIVED_INVENTORY_COUNTS(state, payload) {
      state.counts = payload;
      state.isReceiving = false;
    },
    RECEIVING_INVENTORY_COUNTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVED_INVENTORY_COUNT(state, payload) {
      state = Object.assign(state, {
        counts: [...state.counts, payload],
        isReceiving: false,
      })
    },
    RECEIVING_INVENTORY_COUNT(state) {
      state.isReceiving = true;
    },
    UPDATED_INVENTORY_COUNT(state, payload) {
      let index = state.counts.findIndex(inventorycount => inventorycount._id === payload._id);
      state = Object.assign(state, {
        counts: state.counts.map((inventorycount, i) => {
          if (i === index) {
            return Object.assign({}, inventorycount, payload);
          }
          return inventorycount;
        }),
        isUpdating: false,
        countsMessage: 'InventoryCounts has been updating!',
      })
    },
    UPDATING_INVENTORY_COUNT(state) {
      state.isUpdating = true;
    },
    DELETED_INVENTORY_COUNT(state, payload) {
      let indexToDelete = state.counts.findIndex(inventorycount => inventorycount._id === payload._id);
      let counts = [...state.counts];
      counts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        counts: [...counts],
        isDeleting: false,
        idToDelete: null,
        countsMessage: 'InventoryCount has been Deleted!',
      });
    },
    DELETING_INVENTORY_COUNT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteInventoryCountRequest({dispatch}, payload) {
      try {
        dispatch("deletingInventoryCount", payload);
        let token = localStorage.getItem('token')
        let url = 'https://api.tradexc.com:3000/delete/inventorycount/' + payload._id;
        let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
        let response = await axios({method: "delete", url: url, headers: headers})
        dispatch("deleteInventoryCount", response.data);
        return response.data;
      } catch (error) {
        console.log(error.data);
      }
    },
    async deleteIVJTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/ivjtransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertInventoryCountRequest({dispatch}, payload) {
      dispatch("receivingInventoryCounts");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/inventorycount';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveInventoryCount", response.data);
      return response.data;
    },
    async insertIVJTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/ivjtransaction/" + payload.inventorycountid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getInventoryCountsRequest({dispatch}) {
      dispatch("receivingInventoryCounts");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/inventorycounts';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(res => {
        dispatch("receiveInventoryCounts", res.data);
      })
    },
    async getInventoryCountQueryRequest({dispatch}, payload) {
      try{
        dispatch("receivingInventoryCounts");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/inventorycounts/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveInventoryCounts", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateInventoryCountRequest({dispatch}, payload) {
      dispatch("updatingInventoryCount");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/inventorycount/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateInventoryCount", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    updateInventoryCountTrade({dispatch}, payload) {
      dispatch("updatingInventoryCount");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/inventorycount/trade/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put",url: url,headers: headers,data: payload})
      .then((response)=> {
        dispatch("updateInventoryCount", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateInventoryCountTransaction({dispatch}, payload) {
      try{
        dispatch("receivingInventoryCount");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/ivjtransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingInventoryCount", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    clearInventoryCounts({commit}) {
      commit("CLEAR_INVENTORY_COUNTS")
    },
    receiveInventoryCounts({commit}, payload) {
      commit("RECEIVED_INVENTORY_COUNTS", payload)
    },
    receivingInventoryCounts({commit}) {
      commit("RECEIVING_INVENTORY_COUNTS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receiveInventoryCount({commit}, payload) {
      commit("RECEIVED_INVENTORY_COUNT", payload)
    },
    receivingInventoryCount({commit}) {
      commit("RECEIVING_INVENTORY_COUNT")
    },
    updateInventoryCount({commit}, payload) {
      commit("UPDATED_INVENTORY_COUNT", payload)
    },
    updatingInventoryCount({commit}) {
      commit("UPDATING_INVENTORY_COUNT")
    },
    deleteInventoryCount({commit}, payload) {
      commit("DELETED_INVENTORY_COUNT", payload)
    },
    deletingInventoryCount({commit}, payload) {
      commit("DELETING_INVENTORY_COUNT", payload)
    }
  },
};
